import React from 'react';
import { Send, Calendar, AlertCircle, CheckCircle } from 'lucide-react';

const CONTRACT_TYPES = ['CDI', 'CDD', 'Freelance', 'Stage', 'Alternance'];

const StepDetailForm = ({ stepType, formData, onInputChange }) => {
  switch (stepType) {
    case 'CANDIDATE_SENT':
      return (
        <div className="space-y-4 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
          <h4 className="font-medium text-yellow-800 flex items-center">
            <Send size={16} className="mr-2" />
            Détails de l'envoi au client
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="candidate-sent-client-name" className="block text-sm font-medium text-gray-700 mb-1">
                Nom du client (optionnel)
              </label>
              <input
                id="candidate-sent-client-name"
                type="text"
                value={formData.candidateSent.clientName}
                onChange={(e) => onInputChange('clientName', e.target.value, 'candidateSent')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
              />
            </div>
            <div>
              <label htmlFor="candidate-sent-client-email" className="block text-sm font-medium text-gray-700 mb-1">
                Email du client (optionnel)
              </label>
              <input
                id="candidate-sent-client-email"
                type="email"
                value={formData.candidateSent.clientEmail}
                onChange={(e) => onInputChange('clientEmail', e.target.value, 'candidateSent')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
              />
            </div>
            <div>
              <label htmlFor="candidate-sent-mail-date" className="block text-sm font-medium text-gray-700 mb-1">
                Date d'envoi *
              </label>
              <input id="candidate-sent-mail-date"
                type="datetime-local"
                value={formData.candidateSent.mailSentDate}
                onChange={(e) => onInputChange('mailSentDate', e.target.value, 'candidateSent')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label htmlFor="candidate-sent-follow-up-date" className="block text-sm font-medium text-gray-700 mb-1">
                Date de relance *
              </label>
              <input id="candidate-sent-follow-up-date"
                type="datetime-local"
                value={formData.candidateSent.followUpDate}
                onChange={(e) => onInputChange('followUpDate', e.target.value, 'candidateSent')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                required
              />
            </div>
          </div>
        </div>
      );

    case 'CANDIDATE_INTERVIEW':
      return (
        <div className="space-y-4 p-4 bg-purple-50 rounded-lg border border-purple-200">
          <h4 className="font-medium text-purple-800 flex items-center">
            <Calendar size={16} className="mr-2" />
            Détails de l'entretien
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="candidate-interview-invitation-date" className="block text-sm font-medium text-gray-700 mb-1">
                Date d'envoi de l'invitation *
              </label>
              <input id="candidate-interview-invitation-date"
                type="datetime-local"
                value={formData.candidateInterview.invitationDate}
                onChange={(e) => onInputChange('invitationDate', e.target.value, 'candidateInterview')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label htmlFor="candidate-interview-date" className="block text-sm font-medium text-gray-700 mb-1">
                Date de l'entretien *
              </label>
              <input id="candidate-interview-date"
                type="datetime-local"
                value={formData.candidateInterview.interviewDate}
                onChange={(e) => onInputChange('interviewDate', e.target.value, 'candidateInterview')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="candidate-interview-location" className="block text-sm font-medium text-gray-700 mb-1">
                Lieu de l'entretien *
              </label>
              <input
                id="candidate-interview-location"
                type="text"
                value={formData.candidateInterview.interviewLocation}
                onChange={(e) => onInputChange('interviewLocation', e.target.value, 'candidateInterview')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                placeholder="Bureau, visioconférence, site client..."
                required
              />
            </div>
          </div>
        </div>
      );

    case 'GO_NOGO':
      return (
        <div className="space-y-4 p-4 bg-orange-50 rounded-lg border border-orange-200">
          <h4 className="font-medium text-orange-800 flex items-center">
            <AlertCircle size={16} className="mr-2" />
            Détails de la décision GO / NO-GO
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="go-nogo-decision" className="block text-sm font-medium text-gray-700 mb-1">
                Décision *
              </label>
              <select id="go-nogo-decision"
                value={formData.goNoGo.decision}
                onChange={(e) => onInputChange('decision', e.target.value, 'goNoGo')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                required
              >
                <option value="GO">GO</option>
                <option value="NO_GO">NO GO</option>
              </select>
            </div>
            <div>
              <label htmlFor="go-nogo-tjm" className="block text-sm font-medium text-gray-700 mb-1">
                TJM (&euro;)
              </label>
              <input id="go-nogo-tjm"
                type="number"
                step="0.01"
                value={formData.goNoGo.tjm}
                onChange={(e) => onInputChange('tjm', e.target.value, 'goNoGo')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                placeholder="500"
              />
            </div>
            <div>
              <label htmlFor="go-nogo-projected-start-date" className="block text-sm font-medium text-gray-700 mb-1">
                Date de démarrage prévisionnelle
              </label>
              <input id="go-nogo-projected-start-date"
                type="datetime-local"
                value={formData.goNoGo.projectedStartDate}
                onChange={(e) => onInputChange('projectedStartDate', e.target.value, 'goNoGo')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              />
            </div>
            <div>
              <label htmlFor="go-nogo-end-date" className="block text-sm font-medium text-gray-700 mb-1">
                Date de fin
              </label>
              <input id="go-nogo-end-date"
                type="datetime-local"
                value={formData.goNoGo.endDate}
                onChange={(e) => onInputChange('endDate', e.target.value, 'goNoGo')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="go-nogo-commercial-concession" className="block text-sm font-medium text-gray-700 mb-1">
                Concession commerciale
              </label>
              <textarea id="go-nogo-commercial-concession"
                value={formData.goNoGo.commercialConcession}
                onChange={(e) => onInputChange('commercialConcession', e.target.value, 'goNoGo')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                rows={3}
                placeholder="Conditions particulières ou concession commerciale..."
              />
            </div>
          </div>
        </div>
      );

    case 'SALE':
      return (
        <div className="space-y-4 p-4 bg-green-50 rounded-lg border border-green-200">
          <h4 className="font-medium text-green-800 flex items-center">
            <CheckCircle size={16} className="mr-2" />
            Détails de la vente
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="sale-tjm" className="block text-sm font-medium text-gray-700 mb-1">
                TJM (&euro;) *
              </label>
              <input id="sale-tjm"
                type="number"
                step="0.01"
                value={formData.sale.tjm}
                onChange={(e) => onInputChange('tjm', e.target.value, 'sale')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                placeholder="500"
                required
              />
            </div>
            <div>
              <label htmlFor="sale-contract-type" className="block text-sm font-medium text-gray-700 mb-1">
                Type de contrat *
              </label>
              <select id="sale-contract-type"
                value={formData.sale.contractType}
                onChange={(e) => onInputChange('contractType', e.target.value, 'sale')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                required
              >
                {CONTRACT_TYPES.map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="sale-start-date" className="block text-sm font-medium text-gray-700 mb-1">
                Date de début *
              </label>
              <input id="sale-start-date"
                type="datetime-local"
                value={formData.sale.startDate}
                onChange={(e) => onInputChange('startDate', e.target.value, 'sale')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label htmlFor="sale-end-date" className="block text-sm font-medium text-gray-700 mb-1">
                Date de fin *
              </label>
              <input id="sale-end-date"
                type="datetime-local"
                value={formData.sale.endDate}
                onChange={(e) => onInputChange('endDate', e.target.value, 'sale')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                required
              />
            </div>
            <div className="md:col-span-2">
              <label htmlFor="sale-commercial-concession" className="block text-sm font-medium text-gray-700 mb-1">
                Concession commerciale
              </label>
              <textarea id="sale-commercial-concession"
                value={formData.sale.commercialConcession}
                onChange={(e) => onInputChange('commercialConcession', e.target.value, 'sale')}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                rows={3}
                placeholder="Conditions particulières ou concession commerciale..."
              />
            </div>
          </div>
        </div>
      );

    default:
      return null;
  }
};

export default StepDetailForm;
